// Static registry of feature admin screens, keyed by feature id. Wired at BUILD time by these
// literal imports (no dynamic code loading - DESIGN §12.3/§12.8). Add one entry per feature.
import type { FeatureScreen } from "./contract.js";
import { ExampleNotesScreen } from "../../../features/example-notes/web/index.js";
import { AdmissionsScreen } from "../../../features/admissions/web/index.js";
import { ModerationScreen } from "../../../features/moderation/web/index.js";

export const FEATURE_SCREENS: Record<string, FeatureScreen> = {
  "example-notes": ExampleNotesScreen,
  admissions: AdmissionsScreen,
  moderation: ModerationScreen,
};
